var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "printBagNumber",
      staticClass: "fontSizeStyle",
      attrs: { id: "printBagNumber" },
    },
    [
      _c(
        "div",
        {
          ref: "printBagNumberContent",
          staticClass: "printBagNumberContent",
          staticStyle: {
            "page-break-before": "always",
            "break-inside": "avoid",
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "align-items": "center" } },
            [
              _c("img", {
                staticStyle: { width: "100px" },
                attrs: { src: require("@/assets/ajlogo1.svg"), alt: "tu" },
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    "font-size": "20px",
                    "text-align": "center",
                    flex: "1",
                    "font-weight": "bold",
                    "margin-left": "-100px",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("scripting.returnCodeList")) + " ")]
              ),
            ]
          ),
          _c("div", { staticStyle: { margin: "10px 0" } }, [
            _vm._v(
              " " +
                _vm._s(_vm.$t("seller.licensePlateNumber")) +
                ": " +
                _vm._s(_vm.paramData[0].vehicleNumber) +
                " "
            ),
          ]),
          _c(
            "table",
            {
              staticStyle: {
                width: "100%",
                "border-collapse": "collapse",
                "text-align": "center",
              },
            },
            [
              _c("thead", [
                _c("tr", { staticStyle: { "background-color": "#add88d" } }, [
                  _c("th", [_vm._v(_vm._s(_vm.$t("GlobalSetObj.serial")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("navbar.siteName")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("scripting.returnCode")))]),
                  _c("th", [_vm._v(_vm._s(_vm.$t("scripting.expiryTime")))]),
                  _c("th", [
                    _vm._v(_vm._s(_vm.$t("collectionCenter.Barcode"))),
                  ]),
                ]),
              ]),
              _c(
                "tbody",
                { staticStyle: { "text-align": "center" } },
                _vm._l(_vm.paramData, function (item, index) {
                  return _c("tr", [
                    _c("td", [_vm._v(_vm._s(index + 1 || "--"))]),
                    _c("td", [_vm._v(_vm._s(item.nextSiteIdName || "--"))]),
                    _c("td", [_vm._v(_vm._s(item.returnCode || "--"))]),
                    _c("td", [_vm._v(_vm._s(item.abortTime || "--"))]),
                    _c("td", [_c("svg", { attrs: { id: item.returnCode } })]),
                  ])
                }),
                0
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }